export default "__VITE_ASSET__DJtGu1OC__"